<style scoped lang="scss">
form {
    h2 {
        color: #000;
    }
    ::v-deep(.formkit-select-icon) {
        height: 50px;
        margin: 0;
        padding: 0;
    }
}
main .container .card {
    background-color: rgba(91, 91, 98, 0.08);
}
</style>

<template>
<div>
    <div class="mb-5">
        <h1 class="page-title">{{ title }}</h1>
    </div>
    <div class="max-w-screen-xl mx-auto">
        <div class="flex flex-wrap -mx-4">
        <div class="w-full lg:w-1/4 px-3">
            <div class="mb-5">
            <div class="card w-75 shadow-xl">
                <div class="card-body items-center text-center">
                    <h5 class="card-title">Image Web*</h5>
                    <UploadImage :image-preview-url="getBaseUrl() + '/media/blank2.png'"
                        @image-removed="onImageWebRemoved"
                        @imageUploaded="onImageWebUpload"
                        @error="onImageUploadError"
                    />
                </div>
            </div>
            </div>
            <div class="mb-5">
            <div class="card w-75 shadow-xl">
                <div class="card-body items-center text-center">
                    <h5 class="card-title">Image Mobile*</h5>
                    <UploadImage :image-preview-url="getBaseUrl() + '/media/blank2.png'"
                        @image-removed="onImageMobileRemoved"
                        @imageUploaded="onImageMobileUpload"
                        @error="onImageUploadError"
                    />
                </div>
            </div>
            </div>
        </div>

        <div class="w-full lg:w-3/4 px-4">
        <div class="card w-full shadow-xl">
        <div class="card-body">
            <div class="w-full">
                <FormKit type="form"
                    :actions="false"
                    @submit="onSubmit"
                    #default="{ state: { valid } }"
                    outer-class="w-full"
                    incomplete-message="Veuillez remplir tous les champs correctement"
                >
                <FormKit type="text"
                    name="title"
                    label="Titre *"
                    validation="required|contains_alpha|matches:/^[^/]*$/|length:0,35"
                    :validation-messages="{
                        required: 'Ce champ est obligatoire.',
                        contains_alpha: 'Ce champ doit contenir des lettres..',
                        matches: 'Ce champ ne peut contenir de “/”.',
                        length: 'Ce champ doit contenir au maximum 35 caractères'
                    }"
                />
                <FormKit type="number"
                    name="position"
                    label="Position *"
                    validation="required|min:1"
                    :validation-messages="{
                        required: 'Ce champ est obligatoire.',
                        min: 'Ce champ doit être un nombre décimal superieur à 0',
                    }"
                />
                <FormKit type="text"
                    name="label"
                    label="Label"
                    :validation="validationLabel"
                    :validation-messages="{
                        required: 'Ce champ est obligatoire.',
                        contains_alpha: 'Ce champ doit contenir des lettres..',
                        matches: 'Ce champ ne peut contenir de “/”.',
                        length: validationLabelMessageLength
                    }"
                />
                <FormKit type="text"
                    name="description"
                    label="Description"
                    validation="contains_alpha|matches:/^[^/]*$/|length:0,80"
                    :validation-messages="{
                        required: 'Ce champ est obligatoire.',
                        contains_alpha: 'Ce champ doit contenir des lettres..',
                        matches: 'Ce champ ne peut contenir de “/”.',
                        length: 'Ce champ doit contenir au maximum 80 caractères'
                    }"
                />
                <FormKit 
                    type="select" 
                    label="Type *" 
                    name="itemType" 
                    v-model="form.itemType" 
                    :options="itemTypeOptions" 
                    validation="required" 
                    :validation-messages="{
                    required: 'Ce champ est obligatoire.'
                }" />



                <label class="formkit-label" 
                v-if="form.itemType === '1' || 
                    form.itemType === '2' || 
                    form.itemType === '5'">
                Uuid
            </label>
            <label class="formkit-label" v-if="form.itemType === '4'">Lien de redirection</label>
            <label class="formkit-label" v-show="form.itemType === '4'">Si lien de redirection type voyage, veuillez vous assurer de mettre un de ces formats: </label>
            <label class="formkit-label" v-show="form.itemType === '4'">https://app.club-employes.com/voyage?id=2209{ce_token} : pour être redirigé vers un produit spécifique où 2209 représente l'id de l'offre voyage</label>
            <label class="formkit-label" v-show="form.itemType === '4'">https://app.club-employes.com/voyage{ce_token} : pour être redirigé vers la page d'accueil de voyage</label>
                    
            <label class="formkit-label" v-if="form.itemType === '3'">Mot(s) recherché(s)</label>
            <FormKit type="text" name="itemValue"  v-model="form.itemValue" />
            <FormKit type="hidden" name="middleMenu" v-model="middleMenu" label="middleMenu" />

                <div class="card-actions">
                    <div v-if="loading === false">
                        <FormKit type="submit"
                            :label="submitBtnLabel"
                            :disabled="!valid"
                            :class="{ 'btn-primary': true, 'btn-block': true }"
                        />
                    </div>
                    <FormKit type="button"
                        label="Annuler"
                        @click="onCancel"
                        :class="{ 'btn-secondary': true, 'btn-block': true }"
                    />
                    </div>
                </FormKit>
            </div>
        </div>
        </div>
        </div>
        </div>
    </div>
</div>
</template>

<script lang="ts" setup>
import {onBeforeMount, ref} from 'vue';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import {useRoute, useRouter} from "vue-router";
import UploadImage from "@/components/forms/UploadImage.vue";
import {IMiddleMenuItem} from "@/models/homepage/IMiddleMenuItem";
import { getItemTypeOptions } from '@/_services/homepage/itemTypeServices.ts'; 

const title = ref<string>("Ajouter un encart");
const submitBtnLabel = 'Ajouter';
const router = useRouter();
const loading = ref<boolean>(false);
const route = useRoute();
const uuidMiddleMenu = ref<string>("");
const form = ref<IMiddleMenuItem>({
    imageWeb: null,
    imageMobile: null
});

const url = route.fullPath;
const regex = /middle-menu-item\/([^\/]+)\/add/;
const match = url.match(regex);
const itemTypeOptions = getItemTypeOptions();
let middleMenu = null;
if (match && match.length > 1) {
    middleMenu = match[1];
}


const filledFieldCount = ref<number>(0);

const blockType = route.params.blockType;
let validationLabel = 'contains_alpha|matches:/^[^/]*$/|length:0,15';
let validationLabelMessageLength = 'Ce champ doit contenir au maximum 15 caractères';
if (blockType === 'travel') {
    validationLabel = 'contains_alpha|matches:/^[^/]*$/|length:0,30';
    validationLabelMessageLength = 'Ce champ doit contenir au maximum 30 caractères';
}

const onSubmit = async (formData) => {
    try {
        filledFieldCount.value = 0;
     
        if (null === form.value.imageWeb || null === form.value.imageMobile) {
            swal.warning('Les deux images sont obligatoires.');
            return false;
        }
        const payload = {
            title: formData.title,
            label: formData.label,
            description: formData.description,
            position: parseInt(formData.position),
            imageWeb: form.value.imageWeb.uuid,
            imageMobile: form.value.imageMobile.uuid,
            itemValue: formData.itemValue,
            middleMenu: formData.middleMenu,
            itemType: parseInt(formData.itemType),
        }
        swal.confirm(`Êtes-vous sûr de vouloir ajouter ?`,
            "Annuler",
            submitBtnLabel
        )
            .then((results) => results.isConfirmed && addMiddleMenuItem(payload))
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

onBeforeMount(async () => {
    uuidMiddleMenu.value = route.params.uuid.length ? route.params.uuid as string : "";
});

const addMiddleMenuItem = (data) => {
    ApiService.post('middle_menu_items', data)
        .then(() => {
            loading.value = false;
            swal.info("Ajout avec succès")
                .then((result) => {
                    if (result.isConfirmed) {
                        router.go(-1);
                    }
                });
        })
        .catch((axiosError) => {
            swal.error("Une erreur est survenue lors de l'ajout");
            axiosError.response.data.errors.forEach((error) => {
                if (error.message.startsWith("Item not found for")
                    || error.message.startsWith("Could not convert database value")) {
                    swal.error("Une erreur est survenue au moment de l'ajout, l’uuid ajoutée n’existe pas.");
                    return false;
                }
            });
        });
}

const onCancel = () => {
    swal.confirm(
        "Êtes-vous sûr de vouloir annuler l'ajout ?",
        "Oui",
        "Non"
    ).then((result) => {
        if (result.isDismissed) {
            router.push({
                name: "carouselList"
            });
        }
    });
}

const onImageWebUpload = (image) => {
    form.value.imageWeb = image;
}

const onImageMobileUpload = (image) => {
    form.value.imageMobile = image;
}

const onImageWebRemoved = () => {
    form.value.imageWeb = null;
}

const onImageMobileRemoved = () => {
    form.value.imageMobile = null;
}

const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}
</script>